import { render, staticRenderFns } from "./AddEditPathoComboSetGroupName.vue?vue&type=template&id=385af061&scoped=true"
import script from "./AddEditPathoComboSetGroupName.vue?vue&type=script&lang=js"
export * from "./AddEditPathoComboSetGroupName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385af061",
  null
  
)

export default component.exports